import { createSlice } from "@reduxjs/toolkit";
import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  data: any;
}

const initialState: InitialState = {
  status: ReduxStateType.INIT,
  data: null,
};

const getBirthdaysInMonthDataSlice = createSlice({
  name: "getBirthdaysInMonthData",
  initialState,
  reducers: {
    getBirthdaysInMonthDataStart: (state, action) => {
      state.status = ReduxStateType.LOADING;
    },
    getBirthdaysInMonthDataSuccess: (state, action) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },
    getBirthdaysInMonthDataFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
  },
});

export const {
  getBirthdaysInMonthDataStart,
  getBirthdaysInMonthDataSuccess,
  getBirthdaysInMonthDataFailed,
} = getBirthdaysInMonthDataSlice.actions;

export default getBirthdaysInMonthDataSlice.reducer;
